import { util } from "../../utils";
export default {
  //处理后的ios数据
  data: {}, //所有的对象
  dataTree: {}, //最终的结构树
  controllerTree: {}, //controller树
  getItemById(id) {
    return this.data[id];
  },
  actions: {
    4096: [
      "UISegmentedControl",
      "UIRefreshControl",
      "UISlider",
      "UISwitch",
      "UIPageControl",
      "UIStepper",
      "UIDatePicker"
    ], //Value changed
    // 64: ["UIButton", "UITabBarButton", "UIControl"], // Touch up inside
    64: ["UIControl"], // Touch up inside
    262144: ["UITextField"] // Editing did end
  },
  classes: {
    type: ["UIControl", "UITableView", "UICollectionView"],
    eventType: ["ui_control", "ui_table_view"],
    blackList: []
  },
  getData(res) {
    let objects_arr = res.payload.serialized_objects.objects;
    let data = {};
    for (let i = 0; i < objects_arr.length; i++) {
      let item = objects_arr[i];
      item.orderIndex = "orderIndex";
      if (data[item.id]) {
        lex.log("有重复");
      } else {
        data[item.id] = item;
      }
    }
    return data;
  },
  setDataOrderIndex: function() {
    for (var id in this.data) {
      var item = this.getItemById(id);
      item.orderIndex = this.getOrderIndex(item.orderIndex, item);
    }
  },
  getControllerTree: function(contentTree) {
    var properties = contentTree ? contentTree.properties : "";
    if (properties && properties.rootViewController) {
      var cid = properties.rootViewController.values[0].value;
      contentTree = this.controllerTree = this.getItemById(cid);
      this.getControllerTree(contentTree);
    } else if (properties && properties.childViewControllers) {
      contentTree.childControllers = [];

      var cids = properties.childViewControllers.values[0].value;
      if (cids) {
        for (var i = 0; i < cids.length; i++) {
          contentTree.childControllers.push(this.getItemById(cids[i]));
          this.data[cids[i]].parentControllerId = this.getItemById(
            contentTree.id
          );
          this.getControllerTree(this.getItemById(cids[i]));
        }
        if (properties && properties.view) {
          var viewId = properties.view.values[0].value;
          contentTree.childControllers.push(this.getItemById(viewId));
          this.data[viewId].parentControllerId = this.getItemById(
            contentTree.id
          );
          this.getControllerTree(this.getItemById(viewId));
        }
      }
    }
  },
  //得到最终的结构树
  getDataTree: function(dataTree) {
    var properties = dataTree ? dataTree.properties : null;
    //循环获得子节点并放入child对象中
    if (
      properties &&
      properties.subviews &&
      properties.subviews.values[0].value &&
      properties.subviews.values[0].value.length
    ) {
      var subviews = properties.subviews.values[0].value;
      dataTree.child = {};
      for (var i = 0; i < subviews.length; i++) {
        var childId = subviews[i];
        dataTree.child[childId] = this.getItemById(childId);
        this.getDataTree(dataTree.child[childId]);
      }
    } else {
      dataTree.child = null;
    }
    //获得父节点并放入parent对象中
    if (
      properties &&
      properties.superview &&
      properties.superview.values[0].value
    ) {
      dataTree.parent = {};
      var parentId = properties.superview.values[0].value;
      dataTree.parent[parentId] = this.getItemById(parentId);
    } else {
      dataTree.parent = null;
    }
  },
  indexOfParent: function(panel) {
    var index = 0;
    var parent = this.getItemById(panel.properties.superview.values[0].value);

    var properties = parent ? parent.properties : null;
    if (
      properties &&
      properties.subviews &&
      properties.subviews.values[0].value &&
      properties.subviews.values[0].value.length
    ) {
      var childIds = properties.subviews.values[0].value;
      for (var i = 0; i < childIds.length; i++) {
        var child = this.getItemById(childIds[i]);
        if (child == panel) break;
        if (panel.class[0] == child.class[0]) ++index;
      }
    }
    return index;
  },
  getOrderIndex: function(orderIndex, panel) {
    /*处理匿名类*/
    if (!panel.class[0]) {
      lex.log("疑似匿名类", panel);
      return orderIndex;
    }
    var className = panel.class[0];
    orderIndex += "_" + className;
    var properties = panel ? panel.properties : null;
    if (
      properties &&
      properties.superview &&
      properties.superview.values[0].value
    ) {
      orderIndex += "_" + this.indexOfParent(panel);
      return this.getOrderIndex(
        orderIndex,
        this.getItemById(properties.superview.values[0].value)
      );
    }
    return orderIndex;
  },
  isSelectable: function(item) {
    // 不在黑名单里
    for (let i = 0; i < this.classes.blackList.length; i++) {
      if (item.class.includes(this.classes.blackList[i])) {
        return false
      }
    }
    // 且在白名单里
    for (let i = 0; i < this.classes.type.length; i++) {
      if (item.class.includes(this.classes.type[i])) {
        return true;
      }
    }
    return false;
  },
  getEventType (item) {
    for (let i = 0; i < this.classes.type.length; i++) {
      if (item.class.includes(this.classes.type[i])) {
        return this.classes.type[i]
      }
    }
    return null
  },
  addChoosedStyle: function(orderIndex, eventName) {
    $("div[data-orderIndex='" + orderIndex + "'")
      .addClass("eventVisualizer_panelChecked")
      .attr("title", eventName ? eventName : "");
  },
  getFrame(item) {
    return item.properties.frame.values[0].value;
  },
  getBounds: function(item) {
    return item.properties.bounds.values[0].value;
  },
  isClickable(item) {
    var flag = false;
    if (
      item.properties &&
      !item.properties.hidden.values[0].value &&
      item.properties.userInteractionEnabled.values[0].value &&
      item.properties.frame.values[0].value.Width > 0 &&
      item.properties.frame.values[0].value.Height > 0 &&
      this.isSelectable(item)
    ) {
      flag = true;
    }
    return flag;
  },
  getPosition(panel, position = { top: 0, left: 0 }) {
    position.top +=
      this.getFrame(panel).Y - this.getBounds(panel).Y;
    position.left +=
      this.getFrame(panel).X - this.getBounds(panel).X;
    if (panel.parent) {
      for (var key in panel.parent) {
        if (panel.parent.hasOwnProperty(key)) {
          this.getPosition(panel.parent[key], position);
        }
      }
    }
    return position
  },
  getPath (path, panel, event, flag) {
    if (flag && !panel.parentControllerId) {
      event.path = path;
    }
    if (panel.parentControllerId) {
      if (!event.table_delegate && event.event_type === "ui_table_view") {
        event.table_delegate = panel.parentControllerId.class[0];
      }
      if (!event.collection_delegate && event.event_type === "ui_collection_view") {
        event.collection_delegate = panel.parentControllerId.class[0];
      }
      if (
        panel.parentControllerId.class[0] !== "RootViewController" && 
        !/UITabBar/.test(path) && 
        !panel.parentControllerId.class.includes('UITabBarController')
      ) {
        path += "/" + panel.parentControllerId.class[0];
      }
      flag = true;
      this.getPath(path, panel.parentControllerId, event, flag);
    } else if (panel.parent) {
      for (var key in panel.parent) {
        if (panel.parent.hasOwnProperty(key)) {
          path += "/" + panel.parent[key].class[0];
          this.getPath(path, panel.parent[key], event, flag);
        }
      }
    }
  }
};
